var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccommodationFacilities = function SvgAccommodationFacilities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M18.585 2.08H5.415A3.415 3.415 0 0 0 2 5.495v13.17a3.415 3.415 0 0 0 3.415 3.415h13.17A3.415 3.415 0 0 0 22 18.665V5.495a3.415 3.415 0 0 0-3.415-3.415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.146 12.255c-.782-.861-1.553-1.733-2.334-2.594-1.242-1.382-2.474-2.764-3.715-4.136-.24-.27-.481-.54-.731-.811-.29-.32-.732-.31-1.022.01-.3.34-.61.68-.911 1.021a2208.282 2208.282 0 0 1-4.447 4.948c-.47.52-.941 1.041-1.402 1.572a.73.73 0 0 0-.16.3c-.04.26.17.471.45.471H6.146v5.909c0 .42.29.741.731.731.731-.01 1.462 0 2.204 0h7.771c.07 0 .14 0 .2-.02.331-.08.531-.33.531-.69v-5.93h1.262c.2 0 .36-.08.44-.27.081-.2 0-.36-.13-.511z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M10.742 13.523v2.704H9.208V9.72h1.534v2.538h2.228V9.72h1.534v6.507H12.97v-2.704z"
  })));
};
export default SvgAccommodationFacilities;